import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDisputesConfig } from '../../../../const/activity-config';
import { useActivityContext } from '../../../../context/activity-store';
import useTransaction from '../../../../hooks/use-transaction';
import getTranslation from '../../../../strings/i18n';
import { StyledPrimaryButton } from '../../../../styles/buttons';
import SyfDisputes, { DisputeFeature } from 'digital-disputes';
import { RenderIf } from 'syf-component-library/ui/atoms';
import { StyledModalActions } from '../subcomponents';
var ModalFooter = function (_a) {
    var closeModal = _a.closeModal, disputesButtonEnabled = _a.disputesButtonEnabled, transactionStatus = _a.transactionStatus;
    var t = getTranslation().t;
    var _b = useActivityContext(), isDisplayCondensed = _b.isDisplayCondensed, accountId = _b.accountId, config = _b.config;
    var _c = useTransaction(), changeModal = _c.changeModal, disputesLinkEnabled = _c.disputesLinkEnabled, transactionDetails = _c.transactionDetails, handleNavigate = _c.handleNavigate;
    var launchDisputes = function (flow) {
        if (flow === DisputeFeature.Questionnaire) {
            closeModal();
            changeModal(true);
        }
        if (flow === DisputeFeature.DisputeCenter) {
            closeModal();
            if (disputesLinkEnabled) {
                handleNavigate === null || handleNavigate === void 0 ? void 0 : handleNavigate('disputes');
            }
        }
    };
    return (_jsxs(StyledModalActions, { justifyContent: "end", alignItems: "center", children: [_jsx(RenderIf, { condition: disputesButtonEnabled && transactionStatus === 'POSTED', children: _jsx(SyfDisputes, { accountId: accountId, disputesMFEConfig: getDisputesConfig(config), eligibilityPortalId: "eligibility-container-id", feature: DisputeFeature === null || DisputeFeature === void 0 ? void 0 : DisputeFeature.Eligibility, navigationHandler: handleNavigate, returnToParent: launchDisputes, transaction: transactionDetails }) }), _jsx(StyledPrimaryButton, { className: "ensightencustomevent", "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": "close", "data-type": "close", onClick: closeModal, children: isDisplayCondensed ? t('common.backButton') : t('common.closeButton') })] }));
};
export default ModalFooter;
//# sourceMappingURL=index.js.map